import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Typography } from "@arco-design/web-react";

import { Logo } from "../../components/Logo";
import { VersionLink } from "../../components/VersionLink/VersionLink";
import { getHeaderColor, getHeaderTextColor } from "../../utils/cssVariables";

import "./FooterContent.css"
import { getCurrentThemeName } from "../../theme";

const WE_RULE_ADDRESS = '524 Broadway, New York, NY';

export const FooterContent = () => {
  const { t } = useTranslation();
  const isNycTheme = getCurrentThemeName() === "black";

  const footerLinks = [
    { to: "https://we-rule.com/who-we-are", label: t('footer_navigation.about') },
    { to: "https://we-rule.com/blog", label: t('footer_navigation.blog') },
    { to: "https://we-rule.com/privacy-policy-app", label: t('footer_navigation.privacy_policy') },
  ];

  const renderFooterLink = ({ to, label }: { to: string, label: string }) => (
    <NavLink
      key={to}
      to={to}
      target="_blank"
      className="footer__link"
      style={{ color: getHeaderTextColor() }}
    >
      {label}
    </NavLink>
  );

  return (
    <div className="footer__container" style={{backgroundColor: getHeaderColor()}}>
      <div className={`footer__logo-container${!isNycTheme ? " footer__logo-container--werule" : ""}`}>
        {!isNycTheme ? (
          <>
            <Typography className="footer__powered-by" style={{ color: getHeaderTextColor() }}>{t('footer_navigation.powered_by')}</Typography>
            <Logo size={133} variant="footer" style={{ padding: 0 }} type="werule-powered-by" />
          </>
        ) : (
          <Logo size={180} variant="footer" style={{ padding: 0 }} type="women-nyc-white" />
        )}
      </div>

      {!isNycTheme && <Typography.Paragraph>{WE_RULE_ADDRESS}</Typography.Paragraph>}
      <div>
        {footerLinks.map(renderFooterLink)}
        <a href="https://we-rule.com/privacy-policy-app" className="footer__link" style={{ color: getHeaderTextColor() }}>{t('footer_navigation.support')}</a>
      </div>
      <div className="footer__version">
        <VersionLink />
      </div>
    </div>
  );
};
